module.exports = __webpack_public_path__ + "static/media/app-bg.2aedbb8a.jpg";